import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromInstallmentsPlans from './content-product.reducer';
export const selectContentProductState = createFeatureSelector<fromInstallmentsPlans.IContentProduct>('contentProduct');
export const selectData = createSelector(selectContentProductState, (state: fromInstallmentsPlans.IContentProduct) => {
  return state.data;
});
